var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDrawBank = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8408 8.52051H20.1608C12.92 8.52051 9.29966 8.52051 7.05024 10.7699C5.43064 12.3895 4.97716 14.7198 4.85019 18.6005H43.1514C43.0245 14.7198 42.571 12.3895 40.9514 10.7699C38.702 8.52051 35.0816 8.52051 27.8408 8.52051ZM20.1598 39.2385H27.8398C35.0806 39.2385 38.701 39.2385 40.9504 36.9891C43.1998 34.7397 43.1998 31.1193 43.1998 23.8785C43.1998 23.03 43.1998 22.2312 43.1962 21.4785H4.80342C4.7998 22.2308 4.7998 23.0292 4.7998 23.8772V23.8785V23.8786C4.7998 27.0197 4.7998 29.4795 4.98345 31.4416C5.38602 31.265 5.81001 31.1529 6.2398 31.1051V27.7185C6.2398 25.3326 8.17393 23.3985 10.5598 23.3985C12.9457 23.3985 14.8798 25.3326 14.8798 27.7185V31.1051C15.8204 31.2097 16.7333 31.6226 17.4545 32.3438C19.1416 34.0309 19.1416 36.7662 17.4545 38.4532L16.6812 39.2265C17.7381 39.2385 18.8936 39.2385 20.1598 39.2385ZM36.9598 31.5585C36.9598 30.7632 36.3151 30.1185 35.5198 30.1185H27.8398C27.0445 30.1185 26.3998 30.7632 26.3998 31.5585C26.3998 32.3538 27.0445 32.9985 27.8398 32.9985H35.5198C36.3151 32.9985 36.9598 32.3538 36.9598 31.5585ZM24.4798 31.5585C24.4798 30.7632 23.8351 30.1185 23.0398 30.1185H20.1598C19.3645 30.1185 18.7198 30.7632 18.7198 31.5585C18.7198 32.3538 19.3645 32.9985 20.1598 32.9985H23.0398C23.8351 32.9985 24.4798 32.3538 24.4798 31.5585ZM9.54157 40.2567C10.1039 40.8191 11.0157 40.8191 11.578 40.2567L15.418 36.4167C15.9804 35.8544 15.9804 34.9426 15.418 34.3803C14.8557 33.8179 13.9439 33.8179 13.3816 34.3803L11.9998 35.762V27.7185C11.9998 26.9232 11.3551 26.2785 10.5598 26.2785C9.76451 26.2785 9.1198 26.9232 9.1198 27.7185V35.762L7.73804 34.3803C7.17568 33.8179 6.26392 33.8179 5.70157 34.3803C5.13921 34.9426 5.13921 35.8544 5.70157 36.4167L9.54157 40.2567Z",
    fill: "url(#paint0_linear_10062_19328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10062_19328",
    x1: 4.7998,
    y1: 8.52051,
    x2: 36.4584,
    y2: 46.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6932B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16601"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrawBank, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DrawBank.853064c8.svg";
export { ForwardRef as ReactComponent };